export function calculateProfitMargin(cost, price) {
    const parsedCost = parseFloat(cost);
    const parsedPrice = parseFloat(price);

    if (isNaN(parsedCost) || isNaN(parsedPrice)) {
        return 0;
    }
    if (parsedPrice <= 0) {
        return 0;
    }
    var margin = ((parsedPrice - parsedCost) / parsedPrice) * 100;
    return margin;
}



// WEBPACK FOOTER //
// ./src/utils/profitMargin.js